import { useState } from 'react';
import voltiImg from '../assets/volti.png';

const Volti = ({ message, position = 'fixed', size = 'md', onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const sizeMap = {
    sm: { container: 'w-16 h-16', ring: 'w-[72px] h-[72px]' },
    md: { container: 'w-20 h-20', ring: 'w-[88px] h-[88px]' },
    lg: { container: 'w-28 h-28', ring: 'w-[124px] h-[124px]' },
    xl: { container: 'w-36 h-36', ring: 'w-[156px] h-[156px]' },
  };

  const positionClasses = position === 'fixed'
    ? 'fixed bottom-6 right-6 z-50 cursor-pointer'
    : '';

  const { container, ring } = sizeMap[size];

  return (
    <div
      className={`${positionClasses} group`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      data-testid="volti-mascot"
    >
      {/* Speech bubble */}
      {isHovered && message && (
        <div
          className="absolute bottom-full right-0 mb-3 bg-white rounded-2xl px-4 py-3 shadow-lg border border-green-200 max-w-[220px]"
          style={{ animation: 'fadeSlideUp 0.25s ease-out' }}
          data-testid="volti-speech-bubble"
        >
          <p className="text-sm text-gray-700 font-medium">{message}</p>
          <div className="absolute -bottom-2 right-8 w-4 h-4 bg-white border-r border-b border-green-200 rotate-45" />
        </div>
      )}

      {/* Volti bubble container */}
      <div
        className={`${ring} rounded-full bg-gradient-to-br from-green-100 to-emerald-50 border-[3px] border-green-300 shadow-xl flex items-center justify-center overflow-hidden transition-all duration-300 ${
          isHovered ? 'scale-110 shadow-green-200/50 shadow-2xl border-green-400' : ''
        }`}
      >
        <img
          src={voltiImg}
          alt="Volti - Mascotte Green Teva"
          className={`${container} object-cover drop-shadow-md`}
          draggable={false}
        />
      </div>
    </div>
  );
};

export default Volti;
